import { createFileRoute } from "@tanstack/react-router";

import { InterviewLiveScreen } from "../features/interview/live/components/InterviewLiveScreen.tsx";

function LiveRoute() {
  const { id } = Route.useParams();
  return <InterviewLiveScreen meetingId={id} />;
}

export const Route = createFileRoute("/_app/interviews/$id/live")({
  component: LiveRoute,
});
